import { LiveStateGetResponse } from 'types/live-state';
import { GetHvJson, HvHostMap } from './helpers';

export const GetSessionLiveState = async (sessionUuid: string) => {
	return await GetHvJson<LiveStateGetResponse>({
		path: `/e3-current-stream-state/${sessionUuid}`,
		service: HvHostMap.eventData
	});
};